/**
 * Semantic theme colour names, registered as Mantine virtual colors in the theme. Safe to pass to
 * any Mantine colour prop (`c`, `color`, chart and ring section colours) — Mantine resolves them
 * to the design tokens internally, in both light and dark schemes.
 */
export enum SemanticColor {
    Primary = "primary",
    Success = "success",
    Warning = "warning",
    Error = "error",
}
